/**
 * @generated SignedSource<<cb3922ec25d471dd0849b15c165dded2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextFieldTranslateButton_to$data = {
  readonly locale: Locale;
  readonly readOnly: boolean;
  readonly " $fragmentType": "TranslatableTextFieldTranslateButton_to";
};
export type TranslatableTextFieldTranslateButton_to$key = {
  readonly " $data"?: TranslatableTextFieldTranslateButton_to$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_to">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextFieldTranslateButton_to",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readOnly",
      "storageKey": null
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "e4b4127643a2d4fdbef92b3a314cc502";

export default node;
